import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faFloppyDisk as freeFasFaFloppyDisk,
  faPencil as freeFasFaPencil,
  faUpload as freeFasFaUpload,
  faTrash as freeFasFaTrash,
  faPlus as freeFasFaPlus,
  faMinus as freeFasFaMinus,
  faLeaf as freeFasFaLeaf,
  faSeedling as freeFasFaSeedling,
  faCamera as freeFasFaCamera,
  faCircle as freeFasFaCircle,
  faBreadSlice as freeFasFaBreadSlice,
  faSlash as freeFasFaSlash,
  faCircleInfo as freeFasFaCircleInfo,
  faEye as freeFasFaEye,
  faEyeSlash as freeFasFaEyeSlash,
  faX as freeFasFaX,
  faCartShopping as freeFasFaCartShopping,
  faUpDown as freeFasFaUpDown,
  faCircleCheck as freeFasFaCircleCheck,
  faPhone as freeFasFaPhone,
  faEnvelope as freeFasFaEnvelope,
  faArrowRotateRight as freeFasFaArrowRotateRight
} from '@fortawesome/free-solid-svg-icons'

import {
  faInstagram as freeFabFaInstagram
} from '@fortawesome/free-brands-svg-icons'

library.add(
  freeFasFaFloppyDisk,
  freeFasFaPencil,
  freeFasFaUpload,
  freeFasFaTrash,
  freeFasFaPlus,
  freeFasFaMinus,
  freeFasFaLeaf,
  freeFasFaSeedling,
  freeFasFaCamera,
  freeFasFaCircle,
  freeFasFaBreadSlice,
  freeFasFaSlash,
  freeFasFaCircleInfo,
  freeFasFaEye,
  freeFasFaEyeSlash,
  freeFasFaX,
  freeFasFaCartShopping,
  freeFasFaUpDown,
  freeFasFaCircleCheck,
  freeFasFaPhone,
  freeFasFaEnvelope,
  freeFasFaArrowRotateRight,
  freeFabFaInstagram
)

config.autoAddCss = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('FontAwesomeLayers', FontAwesomeLayers)
Vue.component('FontAwesomeLayersText', FontAwesomeLayersText)
